import panoramicBirthdayCs from '../assets/banners/soft_banner_panoramic_birthday_cs.jpg';
import panoramicBirthdayDe from '../assets/banners/soft_banner_panoramic_birthday_de.jpg';
import panoramicBirthdayEn from '../assets/banners/soft_banner_panoramic_birthday_en.jpg';
import panoramicBirthdayPl from '../assets/banners/soft_banner_panoramic_birthday_pl.jpg';
import panoramicStudioCs from '../assets/banners/soft_banner_panoramic_studio_cs.jpg';
import panoramicStudioDe from '../assets/banners/soft_banner_panoramic_studio_de.jpg';
import panoramicStudioEn from '../assets/banners/soft_banner_panoramic_studio_en.jpg';
import panoramicStudioPl from '../assets/banners/soft_banner_panoramic_studio_pl.jpg';
import mobileBirthdayCs from '../assets/banners/soft_banner_mobile_birthday_cs.jpg';
import mobileBirthdayDe from '../assets/banners/soft_banner_mobile_birthday_de.jpg';
import mobileBirthdayEn from '../assets/banners/soft_banner_mobile_birthday_en.jpg';
import mobileBirthdayPl from '../assets/banners/soft_banner_mobile_birthday_pl.jpg';
import mobileStudioCs from '../assets/banners/soft_banner_mobile_studio_cs.jpg';
import mobileStudioDe from '../assets/banners/soft_banner_mobile_studio_de.jpg';
import mobileStudioEn from '../assets/banners/soft_banner_mobile_studio_en.jpg';
import mobileStudioPl from '../assets/banners/soft_banner_mobile_studio_pl.jpg';

/**
 * Home hero banners shown above stories.
 * Each banner can define separate desktop/mobile assets per locale.
 *
 * @typedef {Object} HomeBannerLocaleAssets
 * @property {string} desktopSrc
 * @property {string} mobileSrc
 * @property {string} alt
 *
 * @typedef {Object} HomeBannerConfig
 * @property {string} id
 * @property {string} fallbackLocale
 * @property {Record<string, HomeBannerLocaleAssets>} locales
 * @property {string} [href]
 */

/** @type {HomeBannerConfig[]} */
export const HOME_BANNERS = [
	{
		id: 'softai-birthday-2026',
		fallbackLocale: 'en',
		locales: {
			en: {
				desktopSrc: panoramicBirthdayEn,
				mobileSrc: mobileBirthdayEn,
				alt: 'Our First Birthday — Celebrate with us',
			},
			pl: {
				desktopSrc: panoramicBirthdayPl,
				mobileSrc: mobileBirthdayPl,
				alt: 'Nasze Pierwsze Urodziny — Świętuj z nami',
			},
			de: {
				desktopSrc: panoramicBirthdayDe,
				mobileSrc: mobileBirthdayDe,
				alt: 'Unser Erster Geburtstag — Feiere mit uns',
			},
			cs: {
				desktopSrc: panoramicBirthdayCs,
				mobileSrc: mobileBirthdayCs,
				alt: 'Naše První Narozeniny — Oslavte je s námi',
			},
		},
	},
	{
		id: 'softai-studio',
		fallbackLocale: 'en',
		href: '/studio',
		locales: {
			en: {
				desktopSrc: panoramicStudioEn,
				mobileSrc: mobileStudioEn,
				alt: 'Create your Softie — Full creative freedom',
			},
			pl: {
				desktopSrc: panoramicStudioPl,
				mobileSrc: mobileStudioPl,
				alt: 'Stwórz swoją Softie — Pełna swoboda kreacji',
			},
			de: {
				desktopSrc: panoramicStudioDe,
				mobileSrc: mobileStudioDe,
				alt: 'Erstelle deinen Softie — Vollständige kreative Freiheit',
			},
			cs: {
				desktopSrc: panoramicStudioCs,
				mobileSrc: mobileStudioCs,
				alt: 'Vytvořte si svou Softie — Plná svoboda tvorby',
			},
		},
	},
];

export const HOME_BANNER_AUTOPLAY_MS = 5000;
export const HOME_BANNER_SLIDE_MS = 640;

/** Native asset widths — used for `sizes` hints only. */
export const HOME_BANNER_DESKTOP_NATIVE_WIDTH = 1280;
export const HOME_BANNER_MOBILE_NATIVE_WIDTH = 628;
export const HOME_BANNER_DESKTOP_ASPECT_RATIO = 5;
export const HOME_BANNER_MOBILE_ASPECT_RATIO = 2;
